import { render, staticRenderFns } from "./LKRoadmapsFeedCardRoadmapUp.vue?vue&type=template&id=00fb8ae8&"
import script from "./LKRoadmapsFeedCardRoadmapUp.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedCardRoadmapUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports